export class ProfileDTO {

public descriptionTemp;
public profileNameTemp;

    constructor(public createDate: string,
        public description: string,
        public modelId: string,
        public profileId: string,
        public profileName: string,
        public updateDate: string,
        public registerId: string,
        public isActive) {

            this.descriptionTemp = description;
            this.profileNameTemp = profileName;

    }


    public profileReset(){
        this.description = this.descriptionTemp;
        this.profileName = this.profileNameTemp;
    }

}